<template>
  <p-modal
    :name="modalName"
    :width="420"
    height="auto"
    :adaptive="true"
    :scrollable="false"
    transition="nice-modal-fade"
    @before-open="reset"
  >
    <div class="password-confirm-content" @click.stop>
      <div class="modal-header">
        <fa icon="lock" fixed-width />
        <h6>Confirm Password</h6>
      </div>
      <div class="modal-body">
        <p class="prompt">
          Enter your password to turn wholesale prices back on.
        </p>

        <form @submit.prevent="onConfirm">
          <text-field
            id="wholesale-price-password"
            v-model="password"
            type="password"
            placeholder="Password"
            autocomplete="current-password"
            :input-class="error ? 'red-background' : ''"
          />
          <p v-if="error" class="error-text">
            {{ error }}
          </p>

          <div class="d-flex align-items-center justify-content-center mt-3">
            <p-button
              type="submit"
              class="mx-2 text-capitalize btn-item-part"
              :disabled="loading || !password"
            >
              {{ loading ? 'Verifying' : 'Confirm' }}
            </p-button>
            <p-button
              type="button"
              class="bg-secondary mx-2 text-capitalize btn-item-part"
              @click="onCancel"
            >
              Cancel
            </p-button>
          </div>
        </form>
      </div>
    </div>
  </p-modal>
</template>

<script>
import { mapActions } from 'vuex'
import PModal from '~/components/core/PModal'
import PButton from '~/components/core/PButton'
import TextField from '~/components/core/Inputs/TextField'

export default {
  name: 'PasswordConfirmModal',
  components: {
    PModal,
    PButton,
    TextField
  },
  props: {
    modalName: {
      type: String,
      default: 'wholesale-price-confirm'
    }
  },
  data: () => ({
    password: '',
    loading: false,
    error: ''
  }),
  methods: {
    ...mapActions({
      enableWholesalePrice: 'auth/enableWholesalePrice'
    }),
    reset () {
      this.password = ''
      this.error = ''
      this.loading = false
    },
    async onConfirm () {
      if (!this.password || this.loading) {
        return
      }
      this.loading = true
      const response = await this.enableWholesalePrice(this.password)
      this.loading = false

      if (response.status === 200) {
        this.$modal.hide(this.modalName)
      } else {
        this.error = response.message || 'Incorrect password'
      }
    },
    onCancel () {
      this.$modal.hide(this.modalName)
    }
  }
}
</script>

<style lang="scss" scoped>

.password-confirm-content {
  .modal-header {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background: #f9f9f9 0% 0% no-repeat padding-box;
    border-bottom: 1px solid #dadada;
    padding: 20px;

    svg {
      font-size: 17px;
    }

    h6 {
      margin-bottom: 0px;
      margin-left: 5px;
    }
  }

  .modal-body {
    padding: 20px;

    .prompt {
      font: normal normal normal 14px/20px Arial;
      color: #000000;
      margin-bottom: 15px;
      text-align: center;
    }

    .error-text {
      font: normal normal normal 13px/18px Arial;
      color: #dc3545;
      margin: 6px 0 0;
    }

    .btn-item-part {
      width: 128px;
      padding-top: 9px;
      padding-bottom: 9px;
    }
  }
}

.nice-modal-fade-enter-active {
  animation: nice-modal-fade-in .3s ease-out;
}

.nice-modal-fade-leave-active {
  animation: nice-modal-fade-out .3s ease-out;
}

@keyframes nice-modal-fade-in {
  0% {
    opacity: 0;
    transform: translateY(-20px) scale(0.9);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes nice-modal-fade-out {
  0% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
  100% {
    opacity: 0;
    transform: translateY(-20px) scale(0.9);
  }
}
</style>
